// Generated by purs version 0.13.0
"use strict";
var Chip_Model_SwitchState = require("../Chip.Model.SwitchState/index.js");
var Chip_Model_Tile = require("../Chip.Model.Tile/index.js");
var Data_Eq = require("../Data.Eq/index.js");
var Data_Map_Internal = require("../Data.Map.Internal/index.js");
var Data_Maybe = require("../Data.Maybe/index.js");
var Data_Ord = require("../Data.Ord/index.js");
var Data_Set = require("../Data.Set/index.js");
var Data_Symbol = require("../Data.Symbol/index.js");
var visibleHint = function (v) {
    var v1 = Data_Map_Internal.lookup(Data_Ord.ordRecord()(Data_Ord.ordRecordCons(Data_Ord.ordRecordCons(Data_Ord.ordRecordNil)()(new Data_Symbol.IsSymbol(function () {
        return "y";
    }))(Data_Ord.ordInt))()(new Data_Symbol.IsSymbol(function () {
        return "x";
    }))(Data_Ord.ordInt)))(v.player.pos)(v.tiles);
    if (v1 instanceof Data_Maybe.Just && v1.value0 instanceof Chip_Model_Tile.Hint) {
        return v.hint;
    };
    return Data_Maybe.Nothing.value;
};
var mapSize = 32;
var outOfLevel = function (v) {
    return v.x < 0 || (v.y < 0 || (v.x >= mapSize || v.y >= mapSize));
};
var isActiveTrap = function (point) {
    return function (level) {
        var v = Data_Map_Internal.lookup(Data_Ord.ordRecord()(Data_Ord.ordRecordCons(Data_Ord.ordRecordCons(Data_Ord.ordRecordNil)()(new Data_Symbol.IsSymbol(function () {
            return "y";
        }))(Data_Ord.ordInt))()(new Data_Symbol.IsSymbol(function () {
            return "x";
        }))(Data_Ord.ordInt)))(point)(level.trapConnections);
        if (Data_Eq.notEq(Data_Maybe.eqMaybe(Chip_Model_Tile.eqTile))(Data_Map_Internal.lookup(Data_Ord.ordRecord()(Data_Ord.ordRecordCons(Data_Ord.ordRecordCons(Data_Ord.ordRecordNil)()(new Data_Symbol.IsSymbol(function () {
            return "y";
        }))(Data_Ord.ordInt))()(new Data_Symbol.IsSymbol(function () {
            return "x";
        }))(Data_Ord.ordInt)))(point)(level.tiles))(new Data_Maybe.Just(Chip_Model_Tile.Trap.value))) {
            return false;
        };
        if (v instanceof Data_Maybe.Just && Data_Eq.eq(Data_Eq.eqRec()(Data_Eq.eqRowCons(Data_Eq.eqRowCons(Data_Eq.eqRowNil)()(new Data_Symbol.IsSymbol(function () {
            return "y";
        }))(Data_Eq.eqInt))()(new Data_Symbol.IsSymbol(function () {
            return "x";
        }))(Data_Eq.eqInt)))(v.value0)(level.player.pos)) {
            return false;
        };
        if (v instanceof Data_Maybe.Just && Data_Set.member(Data_Ord.ordRecord()(Data_Ord.ordRecordCons(Data_Ord.ordRecordCons(Data_Ord.ordRecordNil)()(new Data_Symbol.IsSymbol(function () {
            return "y";
        }))(Data_Ord.ordInt))()(new Data_Symbol.IsSymbol(function () {
            return "x";
        }))(Data_Ord.ordInt)))(v.value0)(level.blocks)) {
            return false;
        };
        return true;
    };
};
var hasEnemy = function (point) {
    return function (v) {
        return Data_Map_Internal.member(Data_Ord.ordRecord()(Data_Ord.ordRecordCons(Data_Ord.ordRecordCons(Data_Ord.ordRecordNil)()(new Data_Symbol.IsSymbol(function () {
            return "y";
        }))(Data_Ord.ordInt))()(new Data_Symbol.IsSymbol(function () {
            return "x";
        }))(Data_Ord.ordInt)))(point)(v.enemies);
    };
};
var isFloor = function (level) {
    return function (pos) {
        var v = Data_Map_Internal.lookup(Data_Ord.ordRecord()(Data_Ord.ordRecordCons(Data_Ord.ordRecordCons(Data_Ord.ordRecordNil)()(new Data_Symbol.IsSymbol(function () {
            return "y";
        }))(Data_Ord.ordInt))()(new Data_Symbol.IsSymbol(function () {
            return "x";
        }))(Data_Ord.ordInt)))(pos)(level.tiles);
        if (Data_Set.member(Data_Ord.ordRecord()(Data_Ord.ordRecordCons(Data_Ord.ordRecordCons(Data_Ord.ordRecordNil)()(new Data_Symbol.IsSymbol(function () {
            return "y";
        }))(Data_Ord.ordInt))()(new Data_Symbol.IsSymbol(function () {
            return "x";
        }))(Data_Ord.ordInt)))(pos)(level.blocks)) {
            return false;
        };
        if (hasEnemy(pos)(level)) {
            return false;
        };
        if (v instanceof Data_Maybe.Nothing) {
            return true;
        };
        if (v instanceof Data_Maybe.Just && v.value0 instanceof Chip_Model_Tile.CloneMachineButton) {
            return true;
        };
        if (v instanceof Data_Maybe.Just && v.value0 instanceof Chip_Model_Tile.Fire) {
            return true;
        };
        if (v instanceof Data_Maybe.Just && v.value0 instanceof Chip_Model_Tile.Water) {
            return true;
        };
        if (v instanceof Data_Maybe.Just && (v.value0 instanceof Chip_Model_Tile.SwitchableWall && v.value0.value0 instanceof Chip_Model_SwitchState.Off)) {
            return true;
        };
        if (v instanceof Data_Maybe.Just && v.value0 instanceof Chip_Model_Tile.Bomb) {
            return true;
        };
        if (v instanceof Data_Maybe.Just && v.value0 instanceof Chip_Model_Tile.Trap) {
            return true;
        };
        if (v instanceof Data_Maybe.Just && v.value0 instanceof Chip_Model_Tile.Ice) {
            return true;
        };
        return false;
    };
};
var enemyAt = function (point) {
    return function (v) {
        return Data_Map_Internal.lookup(Data_Ord.ordRecord()(Data_Ord.ordRecordCons(Data_Ord.ordRecordCons(Data_Ord.ordRecordNil)()(new Data_Symbol.IsSymbol(function () {
            return "y";
        }))(Data_Ord.ordInt))()(new Data_Symbol.IsSymbol(function () {
            return "x";
        }))(Data_Ord.ordInt)))(point)(v.enemies);
    };
};
module.exports = {
    isActiveTrap: isActiveTrap,
    visibleHint: visibleHint,
    mapSize: mapSize,
    outOfLevel: outOfLevel,
    isFloor: isFloor,
    hasEnemy: hasEnemy,
    enemyAt: enemyAt
};
